import React, { useEffect, useState } from "react"
import {
  Button,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { EditableList } from "../../../compnents/list/EditableList"
import { TableRowSelection } from "antd/lib/table/interface"
import { RecordsColumns } from "../columns"
import axios from "axios"
import { ZYTFFormModal } from "./ZYTFFormModal"
import { useHistory } from "react-router-dom"
import { AXIOS_IP, FillingType } from "../fileUploadService"
import { ZYTFAgainModal } from "./ZYTFAgainModal"

export const RecordsModal = (props: {
  visible: boolean
  token: string
  onOk: () => void
  onCancel: () => void
}) => {
  const { Option } = Select

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [detailModalVisible, setDetailModalVisible] = useState(false)

  const [ZYTFAgainVisible, setZYTFAgainVisible] = useState(false)

  const [id, setId] = useState<any>()

  const history = useHistory()

  const [pageLoading, setPageLoading] = useState(false)

  const [againId, setAgainId] = useState<any>()

  const [filingTcmPatchRecordId, setFilingTcmPatchRecordId] = useState<any>()

  const [againName, setAgainName] = useState<any>()

  const [memo, setMemo] = useState<any>()

  const [page, setPage] = useState<any>({
    items: [],
    total: 0,
  })

  const [params, setParams] = useState<any>({
    pageNo: 1,
    pageSize: 10,
  })

  const getData = () => {
    setPageLoading(true)
    axios({
      url: `${AXIOS_IP}/filingReviewTcmPatchRecord/list`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "POST",
      data: { ...params },
    }).then((res) => {
      setPage({
        ...page,
        items: res.data.data?.list || [],
        total: res.data.data?.total || 0,
      })
      setPageLoading(false)
    })
  }

  useEffect(() => {
    if (!props.visible) return
    getData()
  }, [props.visible, params])

  return (
    <>
      <Modal
        title="中医贴敷备案申请记录"
        width={1200}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        footer={null}
        centered
        maskClosable={false}
      >
        <div>
          <EditableList
            style={{ flex: 1, height: "450px" }}
            scroll={{ x: "30rem" }}
            page={{
              items: page.items,
              current: params.pageNo,
              size: params.pageSize,
              total: page.total,
            }}
            pageSizeOptions={["10", "20", "50", "100"]}
            loading={pageLoading}
            rowKey={(m: any) => m.id}
            columns={RecordsColumns(
              params.pageSize * (params.pageNo - 1),
              (action: any, t: any) => {
                switch (action) {
                  case "again":
                    axios({
                      url: `${AXIOS_IP}/filingReviewTcmPatchRecord/detail`,
                      headers: {
                        "Content-Type": "application/json",
                        "His-Auth": props.token,
                      },
                      withCredentials: false,
                      method: "POST",
                      data: { id: t?.id },
                    }).then((res: any) => {
                      if(res.data.data?.filingTcmPatchRecordId) {
                        setAgainId(t.id)
                        setFilingTcmPatchRecordId(res.data.data.filingTcmPatchRecordId)
                        setAgainName(t.drugName)
                        setMemo(t.memo)
                        props.onCancel()
                        setZYTFAgainVisible(true)
                      } else {
                        setMemo(t.memo)
                        setId(t?.id)
                        props.onCancel()
                        setDetailModalVisible(true)
                      }
                    })
                    break
                  case "detail":
                    history.push({
                      pathname: "/filingManagementDetail",
                      state: { id: t.id, state: 2, type: FillingType.ZYTF },
                    })
                    break
                }
              }
            )}
            onChangePage={(current, size) =>
              setParams({ ...params, pageNo: current, pageSize: size || 10 })
            }
            sticky
          />
        </div>
      </Modal>

      <ZYTFFormModal
        visible={detailModalVisible}
        againId={id}
        memo={memo}
        token={props.token}
        onOk={() => {
          setDetailModalVisible(false)
          getData()
        }}
        onCancel={() => setDetailModalVisible(false)}
      />

      <ZYTFAgainModal
        visible={ZYTFAgainVisible}
        token={props.token}
        id={againId}
        memo={memo}
        filingTcmPatchRecordId={filingTcmPatchRecordId}
        againName={againName}
        onOk={() => setZYTFAgainVisible(false)}
        onCancel={() => setZYTFAgainVisible(false)}
      />
    </>
  )
}
